// extracted by mini-css-extract-plugin
module.exports = {"Success":"Success___WP5xU","resourceInfo":"resourceInfo___2dghS","buttons":"buttons___3r4bz"};